import{jsxs as e,Fragment as r,jsx as t}from"react/jsx-runtime";import{twMerge as o}from"tailwind-merge";import i from"../../Utils/BackDrop/BackDrop.js";import"react";import s from"../../Base/Layouts/Box/Box.js";import"../../Base/Layouts/FullBleed/FullBleed.js";import"react-dom";import{directionStyle as a,sizeStyle as l,openStyle as m}from"./Drawer.styles.js";
/**
 * 화면의 가장자리에서 슬라이딩되어 나타나는 서랍형 컴포넌트입니다.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - 서랍이 열려있는지 여부를 결정합니다
 * @param {() => void} props.onClose - 서랍을 닫을 때 실행되는 콜백 함수입니다
 * @param {'left' | 'right' | 'top' | 'bottom'} [props.direction='right'] - 서랍이 나타날 방향을 지정합니다
 * @param {'full' | 'half' | 'third' | 'quarter'} [props.size='quarter'] - 서랍의 크기를 지정합니다
 * @param {string} [props.className] - 추가적인 CSS 클래스를 지정할 수 있습니다
 * @param {React.ReactNode} props.children - 서랍 내부에 표시될 컨텐츠입니다
 *
 * @example
 * // 기본 사용법
 * <Drawer isOpen={isOpen} onClose={() => setIsOpen(false)}>
 *   <div>서랍 내용</div>
 * </Drawer>
 *
 * // 왼쪽에서 나타나는 절반 크기의 서랍
 * <Drawer
 *   isOpen={isOpen}
 *   onClose={() => setIsOpen(false)}
 *   direction="left"
 *   size="half"
 * >
 *   <div>서랍 내용</div>
 * </Drawer>
 */const n=({isOpen:n,onClose:c,direction:d="right",size:p="quarter",className:f,children:u})=>/*#__PURE__*/e(r,{children:[n&&/*#__PURE__*/t(i,{onClick:c,isBlack:!0}),
/*#__PURE__*/t(s,{className:o("fixed z-30 flex flex-col bg-white transition-transform duration-300 ease-in-out",a[d],l(p,d),n&&m[d],f),"data-testid":"design-system-drawer",children:u})]});export{n as default};
